<template lang='pug'>
v-container(fluid class="pa-0")
  v-app-bar(app, flat, dense, fixed, dark, color='primary')
    v-app-bar-nav-icon(@click='toggleDrawerMenu')
    v-toolbar-title(class='subtitle-1') カレンダー
  v-row(class='mr-0 ml-0 pl-4 local-header')
    v-tabs(v-model="tab", color='primary')
      v-tab カレンダーグループ
      v-tab 休日管理
  v-divider  
  v-container
    v-row(v-if='tab===0', class='ma-0', justify='center')
      v-card(tile, flat, max-width='600', width='600')
        v-row(class='ma-0', justify='end')
          v-btn(class='px-2 my-2', text, color='primary', @click='prepareToAdd()')
            v-icon(class='pr-1') group_add
            .body グループ追加
        v-simple-table(class='user-table')
          template(v-slot:default)
            thead
              tr
                th(class='pl-3') ID
                th(class='pl-3') グループ名
                th(class='pa-0') アクション
            tbody
              tr(:class="{'odd': index % 2 == 1}", v-for="(item, index) in groups", :key="item.calendarGroupId")
                td(class='pl-3')
                  span {{item.identifier}}
                td(class='pl-0 py-2')
                  v-text-field(lable='グループ名', v-model='item.name', @change='updateName(item)', dense, hide-details="auto", class='group-name', solo, flat, @focus='addClassActive', @blur='removeClassActive')
                td(class='py-2 px-0', min-width='70', width='140',)
                  v-btn(x-small, depressed, @click='detailGroup(item)', class="my-1 mr-1", outlined, color='primary', width='60') 勤怠区分
                  v-btn(x-small, depressed, @click='deleteGroup(item)', class="my-1", color='error', width='60') 削除
    div(v-else)
      v-row(class='mx-0 mt-2 mb-3', justify='space-between')
        v-card(class='pa-0', flat)
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-btn(class='pl-1 pr-3 mr-1', v-on='on', text, color='primary', @click='previousMonth()')
                v-icon keyboard_arrow_left
                .body {{'前月'}}
            span 前月
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-btn(class='pr-1 pl-3', v-on='on', text, color='primary', @click='nextMonth()')
                .body {{'翌月'}}
                v-icon keyboard_arrow_right
            span 翌月
        v-card(class='pa-0', flat)
          v-tooltip(bottom)
            template(v-slot:activator='{ on }')
              v-btn(class='px-2', v-on='on', text, color='primary', @click='createCalendar()')
                v-icon(class='pr-1') date_range
                .body 休日データ作成
            span この休日データで各グループのカレンダーを作成
      v-row(class='mx-0 mt-3')
        .body-2 {{yearMonthDisp}}
      v-row
        v-col(cols='12', sm="6",md="4", lg="3", v-for="(dateObj, index) in firstCalendars", :key="dateObj.calendarDayId")
          v-card
            v-card-title.subtitle-2 {{ dateObj.dateDisp }}
            v-divider(class='pb-2')
            .calendar-group(class='pb-4')
              v-card-text(v-for="(itemG, indexG) in groups", :key='indexG', class='d-flex flex-column align-stretch pt-0 pb-2')
                div(class='calendar-group d-flex justify-end align-center')
                  div(class='calendar-group__name pr-2') {{ itemG.name }}
                  v-text-field(label='Memo', v-model='groups[indexG].calendars[index].comment', 'dense', @change='saveComment(groups[indexG].calendars[index])', hide-details="auto", class='calendar-group__memo mt-0', single-line)
                  v-checkbox(v-model='groups[indexG].calendars[index].isOffDay', dense, @change='saveIsOffDay(groups[indexG].calendars[index])', class='mt-0 calendar-group__off', hide-details="auto")

    v-dialog(v-model='addingDialog', max-width='400')
      v-card
        v-card-title.subtitle-1 グループ追加
        v-card-text 
          v-row(class='ma-0', justfy='end')
            v-col(class='pa-0 pr-3')
              v-text-field(max-width="60",label='ID', v-model='addingObject.identifier', dense, hide-details="auto")
            v-col(class='pa-0')
              v-text-field(max-width="60",label='グループ名', v-model='addingObject.name', dense, hide-details="auto")
        v-card-actions
          v-spacer
          v-btn(text, @click='addingDialog = false') キャンセル
          v-btn(text, @click='addGroup()') 追加

    v-dialog(v-model='workTypeDialog', max-width='800', scrollable)
      v-card
        v-card-title(class='subtitle-1') {{workTypeObject.name}} 勤怠区分
        v-divider
        v-card-text
          v-row
            v-col(cols='12', sm="6",md="4", lg="3", v-for="item in workTypeObject.groupWorks", :key='item.calendarGroupWorkTypeId')
              v-card
                v-card-title.subtitle-2 {{ item.name }}
                v-divider(class='pb-2')
                v-card-text(class='pt-0 pb-3')
                  v-checkbox(v-model='item.enabled', label="使用する", dense, class='mt-0 calendar-group__label', hide-details="auto", @change='changeGroupWorkType(item, "enabled")')
                  v-checkbox(v-model='item.needsApproval', label="承認必要", dense, class='mt-0 calendar-group__label', hide-details="auto", @change='changeGroupWorkType(item, "needsApproval")')
                  v-checkbox(v-model='item.isDefaultForOffDay', label="オフ日デフォルト", dense, class='mt-0 calendar-group__label', hide-details="auto", @change='changeGroupWorkType(item, "isDefaultForOffDay")')
                  v-checkbox(v-model='item.isDefaultForWorkDay', label="勤務日デフォルト", dense, class='mt-0 calendar-group__label', hide-details="auto", @change='changeGroupWorkType(item, "isDefaultForWorkDay")')
        v-divider
        v-card-actions
          v-spacer
          v-btn(text, @click='workTypeDialog = false') 閉じる
</template>

<script>
import basic from '@/components/mixins/basic'
import moment from "moment-timezone";
moment.locale('ja')

export default {
  mixins: [basic],
  components: {
  },
  computed: {
    firstCalendars() {
      return this.groups.length>0 ? this.groups[0].calendars : []
    },
    yearMonth() {
      return this.yearMonthDate == null ? null : this.yearMonthDate.year() * 100 + this.yearMonthDate.month() + 1
    },
    yearMonthDisp() {
      return this.yearMonthDate == null ? null : this.yearMonthDate.format('YYYY年MM月')
    }
  },
  data() {
    return {
      groups: [],
      yearMonthDate: null,
      addingDialog: false,
      addingObject: {},
      workTypeDialog: false,
      workTypeObject: {},
      tab: null,
    }
  },
  mounted() {
    this.yearMonthDate = moment([moment().year(), moment().month(), 1])
  },
  methods: {
    async masterReady () {
      if (!this.$store.getters['Login/isAdmin']) {
        // redirect to home when you are not admin
        this.$router.push(this.site.deployFolder + "/")
      }
      await this.search()
    },
    async search () {
      this.groups = await this.$store.dispatch("Calendar/getGroups", this.yearMonth);
    },
    async previousMonth () {
      this.yearMonthDate = this.yearMonthDate.clone().add(-1, 'months')
      await this.search()
    },
    async nextMonth () {
      this.yearMonthDate = this.yearMonthDate.clone().add(1, 'months')
      await this.search()
    },
    prepareToAdd() {
      this.addingDialog = true
      this.addingObject = { identifier:'', name:'' }
    },
    detailGroup(item) {
      this.workTypeDialog = true
      this.workTypeObject = item
    },
    async addGroup() {
      await this.$store.dispatch("Calendar/createGroup", this.addingObject);
      this.search();
      this.addingDialog = false
    },
    async updateName(item) {
      var param = { calendarGroupId:item.calendarGroupId, param: 'name', value: item.name }
      await this.$store.dispatch("Calendar/updateGroup", param); 
      this.dispSuccess('グループ名を更新しました')
    },
    async saveComment(item) {
      var param = { calendarDayId:item.calendarDayId, param: 'comment', value: item.comment }
      await this.$store.dispatch("Calendar/updateDay", param); 
      this.dispSuccess('コメントを更新しました')
    },
    async saveIsOffDay(item) {
      var param = { calendarDayId:item.calendarDayId, param: 'isOffDay', value: item.isOffDay }
      await this.$store.dispatch("Calendar/updateDay", param); 
      this.dispSuccess('オフを更新しました')
    },
    async deleteGroup() {
      this.dispSuccess('こちらの機能は未対応です。お問い合わせください。')
    },
    async createCalendar() {
      await this.$store.dispatch('Calendar/createpersonal',  this.yearMonthDate.year() * 100 +  this.yearMonthDate.month() + 1)
      this.dispSuccess('該当月の個人カレンダーを作成しました')
    },
    async changeGroupWorkType(item, parameter) {
      var param = { calendarGroupWorkTypeId:item.calendarGroupWorkTypeId, param: parameter, value: item[parameter] }
      await this.$store.dispatch("Calendar/updateGroupWorkType", param); 
    },
    toggleDrawerMenu () {
      this.$emit('toggle')
    },
    addClassActive(e){
      var input = e.currentTarget.closest(".v-input__control")
      var activeItems = input.closest('tbody').querySelectorAll('.field--active')
      if(activeItems.length > 0){
        activeItems.forEach(e => {
          e.classList.remove('field--active')
        }); 
      }
      input.classList.add("field--active");
    },
    removeClassActive(e){
      var input = e.currentTarget.closest(".v-input__control")
      input.classList.remove("field--active");
    }
  }
};
</script>

<style lang='scss'>
.calendar-group{
  &__name{
    font-size: .75rem;
    line-height: .875rem;
    width: 35%;
  }
  &__memo{
    font-size: .75rem;
    // width: 40%;
  }
  &__off{
    width: 22px;
  }
  &__label{
    font-size: .75rem;
    line-height: .875rem;
  }
}
</style>